import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { GoogleAuthCallbackPage } from "@/features/auth/google/google-auth-callback-page";

const googleCallbackSearchSchema = z.object({
  code: z.string().optional().catch(undefined),
  error: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/auth/google/callback")({
  validateSearch: googleCallbackSearchSchema,
  component: GoogleAuthCallbackPage,
});
